// src/utils/loadScript.ts
export function loadScript(src: string, id?: string, attrs: Record<string, string> = {}) {
    return new Promise<HTMLScriptElement>((resolve, reject) => {
        if (id) {
            const existing = document.getElementById(id) as HTMLScriptElement | null;
            if (existing) return resolve(existing);
        }

        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        if (id) s.id = id;
        Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
        s.onload = () => resolve(s);
        s.onerror = () => reject(new Error(`Failed to load script: ${src}`));
        document.head.appendChild(s);
    });
}
